<template>
    <div class="comBack" @click="backHandle">
          ＜
      </div>
</template>
<script>
export default{
    methods: {
        backHandle(){
            this.$router.back()
        }
    }
}
</script>

<style scoped>
.comBack{
    position: fixed;
    left: 30px;
    bottom: 100px;
    background: rgba(0,0,0,0.5);
    color: #fff;
    font-size: 40px;
    border-radius: 100px;
    text-align: center;
    width: 80px;
    height: 80px;
    line-height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/comBack/comBack.vue